import { createAutocomplete } from '@algolia/autocomplete-core';
import AlgoliaSearch from 'algoliasearch/lite';
import { useCallback, useMemo, useState } from 'react';
import { debounceAutoComplete } from './DebouceAutocomplete';
// TODO: Replace with value from bootstrap config
const searchClient = AlgoliaSearch('7LVR1JKTDF', '3ef48f0fc67ee7e9c5a9dbbf6b45908c');
const useAlgoliaAutocomplete = (inputRef, placeholder) => {
  const [autocompleteState, setAutocompleteState] = useState({
    collections: [],
    completion: null,
    context: {},
    isOpen: false,
    query: '',
    activeItemId: null,
    status: 'idle'
  });
  const debouncedGetSources = useCallback(_ref => {
    let {
      query
    } = _ref;
    if (!query) {
      // TODO: Return recent searches
      return debounceAutoComplete([]);
    }
    return debounceAutoComplete([{
      sourceId: 'querySuggestions',
      getItems() {
        return searchClient.search([{
          indexName: 'marketplace_plugins_prod_query_suggestions',
          query,
          params: {
            hitsPerPage: 6
          }
        }]).then(_ref2 => {
          let {
            results
          } = _ref2;
          //TODO: Transform the results to display query suggestions
          return results[0];
        });
      },
      getItemUrl(_ref3) {
        let {
          item
        } = _ref3;
        return item.url;
      }
    }]);
  }, []);
  const autocomplete = useMemo(() => createAutocomplete({
    id: 'search',
    placeholder,
    openOnFocus: true,
    onStateChange(_ref4) {
      let {
        state
      } = _ref4;
      setAutocompleteState(state);
    },
    getSources: debouncedGetSources
  }), [inputRef]);
  return {
    autocomplete,
    autocompleteState
  };
};
export { useAlgoliaAutocomplete };